import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import grafanaPlugin from '@backstage-community/plugin-grafana/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { apiDocsModule } from './modules/api-docs';
import { grafanaOverviewModule } from './modules/grafana';
import { protoBrowserModule } from './modules/proto-browser';
import { errorReportingModule } from './modules/error-reporting';
import { entityLayoutModule } from './modules/entity-layout';
import { gcpResourcesModule } from './modules/gcp-resources';
import { authModule, oidcAuthApiRef } from './modules/auth';
import techdocsMermaidModule from 'backstage-plugin-techdocs-addon-mermaid/alpha';

import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageProps } from '@backstage/core-plugin-api';

function ConfiguredSignInPage(props: SignInPageProps) {
  if (process.env.NODE_ENV !== 'production') {
    return <SignInPage {...props} providers={['guest']} />;
  }
  return (
    <SignInPage
      {...props}
      providers={[
        {
          id: 'oidc',
          title: 'GOALS SSO',
          message: 'Sign in with your GOALS account',
          apiRef: oidcAuthApiRef,
        },
      ]}
    />
  );
}

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => ConfiguredSignInPage,
  },
});

export default createApp({
  features: [
    catalogPlugin,
    grafanaPlugin,
    errorReportingModule,
    entityLayoutModule,
    gcpResourcesModule,
    authModule,
    navModule,
    homeModule,
    apiDocsModule,
    grafanaOverviewModule,
    protoBrowserModule,
    techdocsMermaidModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
